import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-loading',
  templateUrl: './new-loading.component.html',
  styleUrls: ['./new-loading.component.scss']
})
export class NewLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
